@if (dispatchNote) {
    <dx-form [formData]="dispatchNote" [colCount]="2" [readOnly]="readOnly">
        <dxi-form-item itemType="group">
            <dxi-form-item dataField="companyName" [label]="{ text: 'Customer Name/Company Name' }"> </dxi-form-item>
            <dxi-form-item dataField="siteName"> </dxi-form-item>
            <dxi-form-item
                dataField="jobType"
                editorType="dxSelectBox"
                [editorOptions]="{ dataSource: jobTypes, displayExpr: 'name', valueExpr: 'id' }"
            >
            </dxi-form-item>
            <dxi-form-item [label]="{ text: 'Dumpster Size' }">
                <div *dxTemplate>
                    <dx-radio-group
                        [items]="dumpsters"
                        [(value)]="dispatchNote.dumpsterType"
                        valueExpr="id"
                        displayExpr="size"
                        layout="horizontal"
                        [readOnly]="readOnly"
                    >
                    </dx-radio-group>
                </div>
            </dxi-form-item>
            <dxi-form-item dataField="rentalDate" editorType="dxDateBox"> </dxi-form-item>
            <dxi-form-item itemType="group" [colCount]="2">
                <dxi-form-item dataField="rentalTime"> </dxi-form-item>
                <dxi-form-item>
                    <div *dxTemplate>
                        <dx-radio-group
                            [(value)]="selectedHourSegment"
                            [items]="['AM', 'PM']"
                            (onValueChanged)="rentalHourSegmentChanged($event)"
                            layout="horizontal"
                            [readOnly]="readOnly"
                            class="mt-4"
                        >
                        </dx-radio-group>
                    </div>
                </dxi-form-item>
            </dxi-form-item>
            <dxi-form-item
                dataField="preferredCommunication"
                [label]="{ text: 'Preferred Communication Method' }"
                editorType="dxSelectBox"
                [editorOptions]="{ dataSource: ['Mail', 'Email'] }"
            >
            </dxi-form-item>
            <dxi-form-item dataField="paymentTerms" editorType="dxSelectBox" [editorOptions]="{ dataSource: ['COD', 'CC'] }">
            </dxi-form-item>
        </dxi-form-item>
        <dxi-form-item itemType="group">
            <dxi-form-item
                dataField="billingSameAsService"
                [label]="{ text: 'Service Address Same As Billing' }"
                editorType="dxCheckBox"
                [colSpan]="2"
            >
            </dxi-form-item>
            @if (dispatchNote) {
                <dxi-form-item [label]="{ text: 'Address Lookup' }">
                    <div *dxTemplate>
                        <app-address-lookup (onLocationChanged)="locationChanged($event)"></app-address-lookup>
                    </div>
                </dxi-form-item>
            }
            <dxi-form-item dataField="address1"> </dxi-form-item>
            <dxi-form-item dataField="address2"> </dxi-form-item>
            <dxi-form-item dataField="city"> </dxi-form-item>
            <dxi-form-item itemType="group" [colCount]="2">
                <dxi-form-item dataField="state"> </dxi-form-item>
                <dxi-form-item dataField="zip"> </dxi-form-item>
            </dxi-form-item>
            <dxi-form-item dataField="phone" [label]="{ text: 'Phone #' }"> </dxi-form-item>
            <dxi-form-item dataField="email"></dxi-form-item>
            <dxi-form-item
                dataField="notes"
                [label]="{ text: 'Customer Notes' }"
                editorType="dxTextArea"
                [editorOptions]="{ height: '75px' }"
            >
            </dxi-form-item>
        </dxi-form-item>
    </dx-form>
}
